import { PublicSiteState } from "../../../../../../root/state"
import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { fromJSX, Updater, Widget } from "widgets-for-react"
import { blockInviewHandler } from "../../../drupal/rendering/inview_utils.mod"
import { cookiebar, is_cookie_accepted } from "../cookiebar/cookiebar.widget.mod"
import { CMSState } from "../types.gen"
import { getClassName } from "../utils.gen"




export type IframeBlockProps = {
  index: number
  link: string
  useCookieBar: boolean
  cookiePlaceholder?: JSX.Element | string
  cookieButton?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type IframeBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
  cookies_classname: string	
  cookies_inner_classname: string	
  cookies_text_classname: string	
  cookies_clickable_classname: string
}>


export function IframeBlock(
  props: IframeBlockProps,
  options?: { style?: IframeBlockStyle; key?: string }
): (set_public_site:(output: Updater<PublicSiteState>) => void) => (public_state:PublicSiteState) => Widget<Updater<CMSState>> {
  return (set_public_site) => (public_state) =>
    fromJSX(() => (
        <InView
          as="section"
          onChange={(inView) => blockInviewHandler('iframe', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
          triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
          threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
          id={`io-${options && options.key ? options.key : props.index}`}
          className='block block--iframe block--small ls-block-spacing'
          key={options && options.key ? options.key : `block-${props.index}`}
        >
          <div className='block__inner ls-container'>
            <div className='block__content'>
              {/* <div className={getClassName(options, "iframe_classname", "")}> */}
              {!is_cookie_accepted("video-cookies") ?
                cookiebar(public_state.cookiestate, "video-cookies").run(a_cs => {
                  set_public_site(s1 => {
                    return {...s1, cookiestate:a_cs(s1.cookiestate)}
                  })
                })
                : <iframe className='block__iframe' src={props.link} />

              }
            </div>
          </div>
        </InView>
      )
    )
} 
